// eslint-disable-next-line @typescript-eslint/triple-slash-reference

import { ChangeUnitWrapperComponent } from 'Public_old/src/wrappers/change-unit.wrapper';
import { HomeWrapperComponent } from 'Public_old/src/wrappers/home.wrapper';
import { Routes } from '@angular/router';
import { isWithinVisibaWebView } from '@public/src/modules/is_within_visiba_web_view';
import { LicenceHolderService } from '@services/licence_holder.service';
import { UnitService } from '@services/unit.service';
import { sharedResolution } from '../../src/shared_resolution';
import { AnonymousChatWrapper } from '../wrappers/anonymous-chat.wrapper';
import { AppointmentWrapperComponent } from '../wrappers/appointment.wrapper';
import { CareCompanionWrapper } from '../wrappers/care-companion.wrapper';
import { CareNavigationWrapper } from '../wrappers/care-navigation.wrapper';
import { CreateNewMessageWrapper } from '../wrappers/create-new-message.wrapper';
import { GuestWrapperComponent } from '../wrappers/guest.wrapper';
import { MyAccountWrapperComponent } from '../wrappers/my_account.wrapper';
import { PrivacyPolicyWrapperComponent } from '../wrappers/privacy_policy.wrapper';
import { ReceptionHomeWrapperComponent } from '../wrappers/reception-home.wrapper';
import { RedRobinWrapper } from '../wrappers/red_robin.wrapper';
import { SignInWrapperComponent } from '../wrappers/sign-in.wrapper';
import { SignInFinishWrapperComponent } from '../wrappers/sign-in-finish.wrapper';
import { TermsOfServiceWrapperComponent } from '../wrappers/terms_of_service.wrapper';
import { EmbeddedWebComponent } from './Components/embedded-web.component';
import { SecurityLevel } from './Constants/securityLevel';
import { ConfirmLeaveGuard } from './Guards/confirm-leave.guard';
import { ViewGuard } from './Guards/view.guard';
import { ComponentsComponent } from './Views/Develop/components.component';
import { GuestComponent } from './Views/Guest/guest.component';
import { ProxyRedirectComponent } from './Views/ProxyRedirect/ProxyRedirect.component';

export function root(): Routes {
	const unitService = sharedResolution.resolve(UnitService);
	const licenceHolderService = sharedResolution.resolve(LicenceHolderService);
	const routes: Routes = [{ path: '**', redirectTo: 'error/404' }];

	for (const unit of unitService.units.values()) {
		const isRoot = unit.id === unitService.rootUnit.id;

		if (isRoot) {
			if (!unit.isEntrance) {
				routes.push({
					path: unit.route,
					component: HomeWrapperComponent,
					canActivate: [ViewGuard],
					data: { access: SecurityLevel.Public },
				});
			}

			routes.push(
				{
					path: `${unit.route}/care-companion/:sessionId`,
					component: CareCompanionWrapper,
					canActivate: [ViewGuard],
					data: { access: SecurityLevel.Client, availibleToNonEntrance: true },
				},
				{
					path: `${unit.route}/my-account`,
					component: MyAccountWrapperComponent,
					canActivate: [ViewGuard],
					data: { access: SecurityLevel.Client, availibleToNonEntrance: true },
				},
				{
					path: `${unit.route}/visits`,
					loadChildren: () => import('./Views/Visits/visits.module').then((m) => m.VisitsModule),
					canActivate: [ViewGuard],
					data: { access: SecurityLevel.Public },
				},
				{
					path: `${unit.route}/cookie-policy`,
					loadChildren: () => import('./Views/CookiePolicy/cookiePolicy.module').then((m) => m.CookiePolicyModule),
				},
				{
					path: `${unit.route}/privacy-policy`,
					component: PrivacyPolicyWrapperComponent,
				},
				{
					path: `${unit.route}/terms-of-Service`,
					component: TermsOfServiceWrapperComponent,
				},
				{
					path: `${unit.route}/change`,
					component: ChangeUnitWrapperComponent,
					canActivate: [ViewGuard],
					data: { access: SecurityLevel.Public },
				},
				{
					path: `${unit.route}/change-unit`,
					component: ChangeUnitWrapperComponent,
					canActivate: [ViewGuard],
					data: { access: SecurityLevel.Public },
				},
				{
					path: `${unit.route}/sign-in`,
					component: SignInWrapperComponent,
					canActivate: [ViewGuard],
					data: { access: SecurityLevel.Public },
				},
			);

			if (__visiba_feature_flags__['CareExperience.PW.Idp']) {
				routes.push({
					path: `${unit.route}/sign-in-finish`,
					component: SignInFinishWrapperComponent,
					canActivate: [ViewGuard],
					data: { access: SecurityLevel.Public },
				});
			}
		}

		if (unit.isEntrance) {
			routes.push(
				{
					path: unit.route,
					component: ReceptionHomeWrapperComponent,
					canActivate: [ViewGuard],
					data: { access: SecurityLevel.Public },
				},
				{
					path: `${unit.route}/_dev`,
					component: ComponentsComponent,
					canActivate: [ViewGuard],
					data: { access: SecurityLevel.Developer },
				},
				{
					path: `${unit.route}/message`,
					component: CreateNewMessageWrapper,
					canActivate: [ViewGuard],
					data: { access: SecurityLevel.Client },
				},
				{
					path: `${unit.route}/message/start`,
					component: CreateNewMessageWrapper,
					canActivate: [ViewGuard],
					data: { access: SecurityLevel.Client },
				},
				{
					path: `${unit.route}/message/who-is-respondent`,
					component: CreateNewMessageWrapper,
					canActivate: [ViewGuard],
					data: { access: SecurityLevel.Client },
				},
				{
					path: `${unit.route}/message/access`,
					component: CreateNewMessageWrapper,
					canActivate: [ViewGuard],
					data: { access: SecurityLevel.Client },
				},
				{
					path: `${unit.route}/message/error`,
					component: CreateNewMessageWrapper,
					canActivate: [ViewGuard],
					data: { access: SecurityLevel.Client },
				},
				{
					path: `${unit.route}/message/reason-for-visit`,
					component: CreateNewMessageWrapper,
					canActivate: [ViewGuard],
					data: { access: SecurityLevel.Client },
				},
				{
					path: `${unit.route}/message/conclusion`,
					component: CreateNewMessageWrapper,
					canActivate: [ViewGuard],
					data: { access: SecurityLevel.Client },
				},
				{
					path: `${unit.route}/message/closed`,
					component: CreateNewMessageWrapper,
					canActivate: [ViewGuard],
					data: { access: SecurityLevel.Public },
				},
				{
					path: `${unit.route}/message/forms`,
					component: CreateNewMessageWrapper,
					canActivate: [ViewGuard],
					data: { access: SecurityLevel.Client },
				},
				{
					path: `${unit.route}/message/forms/:formId`,
					component: CreateNewMessageWrapper,
					canActivate: [ViewGuard],
					data: { access: SecurityLevel.Client },
				},
				{
					path: `${unit.route}/message/forms/:formId/:page`,
					component: CreateNewMessageWrapper,
					canActivate: [ViewGuard],
					data: { access: SecurityLevel.Client },
				},
				{
					path: `${unit.route}/message/done`,
					component: CreateNewMessageWrapper,
					canActivate: [ViewGuard],
					data: { access: SecurityLevel.Client },
				},
				{
					path: `${unit.route}/message/done/:conversationId`,
					component: CreateNewMessageWrapper,
					canActivate: [ViewGuard],
					data: { access: SecurityLevel.Client },
				},
				{
					path: `${unit.route}/message/anonymous-chat`,
					component: AnonymousChatWrapper,
				},
				{
					path: `${unit.route}/message/anonymous-chat/:catchAll`,
					component: AnonymousChatWrapper,
				},
				{
					path: `${unit.route}/message/anonymous-chat/chat/:catchAll`,
					component: AnonymousChatWrapper,
					canDeactivate: [ConfirmLeaveGuard],
				},
				{
					path: `${unit.route}/message/info`,
					redirectTo: `${unit.route}/message`,
				},
				{
					path: `${unit.route}/ew`,
					component: EmbeddedWebComponent,
					canActivate: [ViewGuard],
					data: { access: SecurityLevel.Public },
				},
				{
					path: `${unit.route}/triage`,
					component: RedRobinWrapper,
					canActivate: [ViewGuard],
					data: { access: SecurityLevel.Client },
				},
				{
					path: `${unit.route}/triage/:catchAll`,
					component: RedRobinWrapper,
					canActivate: [ViewGuard],
					data: { access: SecurityLevel.Client },
				},
				{
					path: `${unit.route}/guest-participant`,
					redirectTo: `${licenceHolderService.alias}`,
				},
				{
					path: `${unit.route}/guest-participant/:callTicket`,
					component: getGuestComponent(),
					canActivate: [ViewGuard],
					data: { access: SecurityLevel.Public, availibleToNonEntrance: true },
				},
				{
					path: `${unit.route}/guest-participant/legacy/:callTicket`,
					component: GuestComponent,
					canActivate: [ViewGuard],
					data: { access: SecurityLevel.Public, availibleToNonEntrance: true },
				},
				{
					path: `${unit.route}/guest-participant/new/:callTicket`,
					component: GuestWrapperComponent,
					canActivate: [ViewGuard],
					data: { access: SecurityLevel.Public, availibleToNonEntrance: true },
				},
				{ path: `${unit.route}/completeRegistration`, component: ProxyRedirectComponent },

				{
					path: `${unit.route}/appointment/:callTicket`,
					component: AppointmentWrapperComponent,
					canActivate: [ViewGuard],
					data: { access: SecurityLevel.ResourceOrClientOrOutsider },
				},
				{
					path: `${unit.route}/booking`,
					canActivate: [ViewGuard],
					data: { access: SecurityLevel.ClientIfUseRepresentatives },
					loadChildren: () => import('../wrappers/booking.wrapper').then((m) => m.BookingWrapperModule),
				},
				{ path: `${unit.route}/error`, loadChildren: () => import('./Views/Error/error.module').then((m) => m.ErrorModule) },
				{
					path: `${unit.route}/form`,
					loadChildren: () => import('./Views/DynamicForm/dynamicform.module').then((m) => m.DynamicFormModule),
				},
				{ path: `${unit.route}/dropin`, loadChildren: () => import('./Views/DropIn/dropin.module').then((m) => m.DropInModule) },
				// Legacy deeplink support
				// https://visibacare.atlassian.net/wiki/spaces/PROD/pages/1281359982/How+to+create+the+right+deep+link
				{
					path: `${unit.route}/visits`,
					redirectTo: `${licenceHolderService.alias}/visits`,
				},
				{
					path: `${unit.route}/profile`,
					redirectTo: `${licenceHolderService.alias}/profile`,
				},
				{
					path: `${unit.route}/navigation`,
					component: CareNavigationWrapper,
					canActivate: [ViewGuard],
					data: { access: SecurityLevel.Client },
				},
				{
					path: `${unit.route}/navigation/:catchAll`,
					component: CareNavigationWrapper,
					canActivate: [ViewGuard],
					data: { access: SecurityLevel.Client },
				},
			);
		}
	}

	return routes;
}

function getGuestComponent() {
	if (isWithinVisibaWebView()) return GuestComponent;
	if (__visiba_feature_flags__['CareExperience.PW.Idp']) return GuestWrapperComponent;

	return GuestComponent;
}
